import { ArrowBackIos, ArrowForwardIos, ConfirmationNumber } from '@mui/icons-material';
import { Alert, Box, IconButton, Typography, Tooltip } from '@mui/material';
import { useState } from 'react';

import type { TicketInterface } from 'types';

interface TicketNavigatorProps {
    tickets: TicketInterface[];
}

const TicketNavigator = ({ tickets }: TicketNavigatorProps) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (tickets.length === 0) return null;

    const handlePrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + tickets.length) % tickets.length);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % tickets.length);
    };

    const currentTicket = tickets[currentIndex];

    return (
        <Alert
            severity="warning"
            icon={<ConfirmationNumber />}
            sx={{
                py: 0.5,
                px: 2,
                '& .MuiAlert-message': {
                    width: '100%',
                    overflow: 'hidden',
                },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {tickets.length > 1 && (
                    <IconButton
                        size="small"
                        onClick={handlePrevious}
                        sx={{ p: 0.5, color: 'warning.dark' }}
                    >
                        <ArrowBackIos sx={{ fontSize: 14 }} />
                    </IconButton>
                )}

                {tickets.length > 1 && (
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 700,
                            bgcolor: 'warning.dark',
                            color: 'white',
                            px: 1,
                            py: 0.25,
                            borderRadius: 1,
                            minWidth: 40,
                            textAlign: 'center',
                        }}
                    >
                        {currentIndex + 1}/{tickets.length}
                    </Typography>
                )}

                <Tooltip title={currentTicket?.text || ''} placement="top" arrow>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 0,
                        }}
                    >
                        {currentTicket?.text || 'Pending feedback'}
                    </Typography>
                </Tooltip>

                {tickets.length > 1 && (
                    <IconButton
                        size="small"
                        onClick={handleNext}
                        sx={{ p: 0.5, color: 'warning.dark' }}
                    >
                        <ArrowForwardIos sx={{ fontSize: 14 }} />
                    </IconButton>
                )}
            </Box>
        </Alert>
    );
};

export default TicketNavigator;
